<template lang="pug">
modal#qualified-signature-list-certificates-plugin-modal(
  :close-button-label='$t("button.cancel")'
  :disable-process-button='!pin'
  :process-button-label='$t("button.next")'
  :title='$t("modal.qualifiedSignatureCertificatePluginModal.needsPin.title")'
  @closed='closed'
  @process='confirm'
  data-bs-backdrop='static'
  data-bs-keyboard='false'
  ref='modal'
  size='sm'
)
  p {{ $t('modal.qualifiedSignatureCertificatePluginModal.needsPin.description', { certificateName: certificate?.CommonName }) }}
  p {{ $t('modal.qualifiedSignatureCertificatePluginModal.needsPin.certificateEmail', { userEmail }) }}
  label(for='certificate-pin') {{ $t('modal.qualifiedSignatureCertificatePluginModal.needsPin.message') }}
  input#certificate-pin.form-control(
    @input='$emit("clear-error")'
    type='password'
    v-model='pin'
  )
  .alert.alert-danger(v-if='errorMsg') {{ errorMsg }}
</template>
<script>
import Modal from '@/ui/molecules/Modal.vue';
import CardTable from '@/ui/organisms/CardTable.vue';
export default {
  name: 'QualifiedSignaturePinPluginModal',
  components: {
    Modal,
    CardTable,
  },
  props: {
    certificate: {
      type: Object,
    },
    userEmail: {
      type: String,
    },
    errorMsg: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      pin: '',
    };
  },
  methods: {
    confirm() {
      this.$loading(true);
      this.$emit('confirmed', this.pin);
    },
    closed() {
      this.$loading(false);
      this.$refs.modal.close();
      this.$emit('closed');
    },
  },
};
</script>
<style lang="stylus"></style>
